import { constants, EndPoint, messages } from "../common/constants";
import swal from "sweetalert";
import _ from "lodash";
import { BASE_URI, serviceAPIMapping } from "../config/service-api-mapping";

export const HandleAPIException = async (response: any) => {
  let responseJson = await response.json();
  let error = messages.statuserror;
  if (responseJson.error) error = responseJson.error;
  swal({
    title: constants.Error,
    text: error,
    dangerMode: true,
    closeOnClickOutside: false,
  });
};

export const contractByBorrowType = async (
  tokenType: any,
  accessToken: any,
  accId: any
) => {
  var ContractsByBorrorwHeader = new Headers();
  ContractsByBorrorwHeader.append(
    "Authorization",
    `${tokenType} ${accessToken}`
  );
  ContractsByBorrorwHeader.append("Content-Type", "application/json");

  var raw = JSON.stringify([
    {
      contract_type: "B",
      account_id: accId,
      order: "string",
      order_by: "string",
      page_number: 0,
      page_size: 0,
    },
  ]);

  var requestOptions: any = {
    method: "POST",
    headers: ContractsByBorrorwHeader,
    body: raw,
    redirect: "follow",
  };

  return await fetch(
    `${serviceAPIMapping["LOANETCONTRACT-SERVICE"].apiRouteURL}${EndPoint.loansAndBorrows}?account_id=${accId}`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const contractByLoneType = async (
  tokenType: any,
  accessToken: any,
  accId: any
) => {
  var ContractsByLoneHeader = new Headers();
  ContractsByLoneHeader.append("Authorization", `${tokenType} ${accessToken}`);
  ContractsByLoneHeader.append("Content-Type", "application/json");

  var raw = JSON.stringify([
    {
      contract_type: "L",
      account_id: accId,
      order: "string",
      order_by: "string",
      page_number: 0,
      page_size: 0,
    },
  ]);

  var requestOptions: any = {
    method: "POST",
    headers: ContractsByLoneHeader,
    body: raw,
    redirect: "follow",
  };

  return await fetch(
    `${serviceAPIMapping["LOANETCONTRACT-SERVICE"].apiRouteURL}${EndPoint.loansAndBorrows}?account_id=${accId}`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const getCptyTextField = async () => {
  var cptyHeader = new Headers();
  cptyHeader.append("Content-Type", "application/json");
  const token = window.localStorage.getItem("refreshtoken");
  cptyHeader.append("Authorization", `Bearer ${token}`);

  var raw = JSON.stringify({
    pageCount: 0,
    pageNumber: 0,
  });

  var requestOptions: any = {
    method: "POST",
    headers: cptyHeader,
    body: raw,
    redirect: "follow",
  };

  return fetch(
    `${serviceAPIMapping["COUNTERPARTY-SERVICE"].apiRouteURL}${EndPoint.getCptyDetails}`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const getTickerTextField = async () => {
  var tikerHeader = new Headers();
  tikerHeader.append("Content-Type", "application/json");
  const token = window.localStorage.getItem("refreshtoken");
  tikerHeader.append("Authorization", `Bearer ${token}`);
  var raw = JSON.stringify({
    pageNumber: 0,
    pageSize: 0,
  });

  var requestOptions: any = {
    method: "POST",
    headers: tikerHeader,
    body: raw,
    redirect: "follow",
  };

  const accountId = window.localStorage.getItem("activeAccountCode");

  return await fetch(
    `${serviceAPIMapping["SECMASTER-SERVICE"].apiRouteURL}${EndPoint.secMaster}?account_id=${accountId}`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const bookContract = async (
  objData: any,
  tokenType: any,
  accessToken: any
) => {
  var bookContractHeader = new Headers();
  bookContractHeader.append("Authorization", `${tokenType} ${accessToken}`);
  bookContractHeader.append("Content-Type", "application/json");
  var raw = JSON.stringify(objData);
  var requestOptions: any = {
    method: "POST",
    headers: bookContractHeader,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${serviceAPIMapping["CONTRACT-BOOKING-SERVICE"].apiRouteURL}${EndPoint.bookContract}`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const statusContract = async (
  statusObj: any,
  tokenType: any,
  accessToken: any
) => {
  var statusHeaders = new Headers();
  statusHeaders.append("Authorization", `${tokenType} ${accessToken}`);
  statusHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify(statusObj);
  var requestOptions: any = {
    method: "POST",
    headers: statusHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${
      serviceAPIMapping["CONTRACT-BOOKING-SERVICE"].apiRouteURL +
      EndPoint.contractStatus
    }`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const SigninApi = async (Data: any) => {
  var singinHeaders = new Headers();
  singinHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(Data);

  var requestOptions: any = {
    method: "POST",
    headers: singinHeaders,
    body: raw,
    redirect: "follow",
  };

  return await fetch(
    `${serviceAPIMapping["AUTH-SERVICE"].apiRouteURL}${EndPoint.authBase}${EndPoint.signIn}`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const SaveTradeStateList = async (
  Data: any,
  tokenType: any,
  accessToken: any
) => {
  var SaveTradeHeaders = new Headers();
  SaveTradeHeaders.append("Authorization", `${tokenType} ${accessToken}`);
  SaveTradeHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(Data);
  var requestOptions: any = {
    method: "POST",
    headers: SaveTradeHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${
      serviceAPIMapping["TRADE-SERVICE"].apiRouteURL +
      EndPoint.saveTradeStateList
    }`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

// export const getTradesStateByID = async (Data: any, id: any) => {
//   var getTradesHeaders = new Headers();
//   getTradesHeaders.append("Content-Type", "application/json");

//   var raw = JSON.stringify(Data);

//   var requestOptions: any = {
//     method: "POST",
//     headers: getTradesHeaders,
//     body: raw,
//     redirect: "follow",
//   };

//   return await fetch(
//     `${BASE_URl_TRADE()}getTradesStateByID/${id}`,
//     requestOptions
//   )
//     .then(async (response) => {
//       if (response.status === 200) {
//         return response;
//       } else if (response.status === 401) {
//         window.localStorage.clear();
//       } else {
//         HandleAPIException(response);
//       }
//       return response;
//     })
//     .catch((error) => console.log("error", error));
// };

export const getTradesStateByUserName = async (
  userName: any,
  tokenType: any,
  accessToken: any
) => {
  var getTradesHeaders = new Headers();
  getTradesHeaders.append("Authorization", `${tokenType} ${accessToken}`);
  getTradesHeaders.append("Content-Type", "application/json");

  var requestOptions: any = {
    method: "GET",
    headers: getTradesHeaders,
    redirect: "follow",
  };

  return await fetch(
    `${serviceAPIMapping["TRADE-SERVICE"].apiRouteURL}${EndPoint.getTradesState}/${userName}`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const deleteTradeState = async (
  uiTradeId: any,
  tokenType: any,
  accessToken: any
) => {
  var deleteTradeHeaders = new Headers();
  deleteTradeHeaders.append("Authorization", `${tokenType} ${accessToken}`);
  deleteTradeHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(uiTradeId);

  var requestOptions: any = {
    method: "DELETE",
    headers: deleteTradeHeaders,
    body: raw,
    redirect: "follow",
  };

  return await fetch(
    `${
      serviceAPIMapping["TRADE-SERVICE"].apiRouteURL + EndPoint.deleteTradeState
    }`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const updateTradeState = async (
  Data: any,
  tokenType: any,
  accessToken: any
) => {
  var updateTradeHeaders = new Headers();
  updateTradeHeaders.append("Authorization", `${tokenType} ${accessToken}`);
  updateTradeHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(Data);

  var requestOptions: any = {
    method: "PUT",
    headers: updateTradeHeaders,
    body: raw,
    redirect: "follow",
  };

  return await fetch(
    `${
      serviceAPIMapping["TRADE-SERVICE"].apiRouteURL + EndPoint.updateTradeState
    }`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const fetchStockLoanKPI = async (
  tokenType: any,
  accessToken: any,
  accountId: any
) => {
  var getKPIHeaders = new Headers();
  getKPIHeaders.append("Authorization", `${tokenType} ${accessToken}`);
  getKPIHeaders.append("Content-Type", "application/json");

  var requestOptions: any = {
    method: "GET",
    headers: getKPIHeaders,
    redirect: "follow",
  };

  return await fetch(
    `${serviceAPIMapping["LOANETCONTRACT-SERVICE"].apiRouteURL}${EndPoint.contractBrowserKPI}${accountId}`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        // HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const getOpenContractValueByCptyID = async (
  Data: any,
  tokenType: any,
  accessToken: any
) => {
  var OpenContracHeaders = new Headers();
  OpenContracHeaders.append("Authorization", `${tokenType} ${accessToken}`);
  OpenContracHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    openContractValueByCptyIDDTOList: Data,
  });

  var requestOptions: any = {
    method: "POST",
    headers: OpenContracHeaders,
    body: raw,
    redirect: "follow",
  };

  return await fetch(
    `${serviceAPIMapping["CONTRACT-BOOKING-SERVICE"].apiRouteURL}/${EndPoint.getOpenContractValueByCptyID}`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const refreshToken = async (refreshToken: any) => {
  var getRefreshToken = new Headers();
  getRefreshToken.append(
    "Authorization",
    `Bearer ${window.localStorage.getItem("refreshtoken")}`
  );
  getRefreshToken.append("Content-Type", "application/json");
  var requestOptions: any = {
    method: "POST",
    headers: getRefreshToken,
    body: JSON.stringify({
      refreshToken: window.localStorage.getItem("refreshtoken"),
    }),
    redirect: "follow",
  };

  return await fetch(
    `${
      serviceAPIMapping["AUTH-SERVICE"].apiRouteURL +
      "/api/" +
      EndPoint.refreshToken
    }`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const SignOutApi = async () => {
  let tempSignOutObj: any = {
    refreshToken: {},
  };
  let name = window.localStorage.getItem("username");
  if (_.isNull(name) || _.isEmpty(name) || _.isUndefined(name)) return;
  var singoutHeaders = new Headers();
  singoutHeaders.append("Authorization", `${tempSignOutObj}`);
  singoutHeaders.append("Content-Type", "application/json");
  singoutHeaders.append("Access-Control-Allow-Origin", "*");
  singoutHeaders.append(
    "Access-Control-Allow-Headers",
    "Origin, X-Requested-With, Content-Type, Accept"
  );
  var requestOptions: any = {
    method: "POST",
    headers: singoutHeaders,
    body: JSON.stringify({
      username: name,
    }),
    redirect: "follow",
  };

  return await fetch(
    `${serviceAPIMapping["AUTH-SERVICE"].apiRouteURL}${EndPoint.authBase}${EndPoint.signOut}`,
    requestOptions
  )
    .then(async (response) => {
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const getContractActivity = async (
  request: any,
  tokenType: any,
  accessToken: any
) => {
  var statusHeaders = new Headers();
  statusHeaders.append("Authorization", `${tokenType} ${accessToken}`);
  statusHeaders.append("Content-Type", "application/json");
  var requestOptions: any = {
    method: "GET",
    headers: statusHeaders,
    redirect: "follow",
  };
  return await fetch(
    `${
      serviceAPIMapping["LOANETCONTRACT-SERVICE"].apiRouteURL +
      EndPoint.contractActivity +
      encodeURIComponent(request.contractId)
    }&bl=${encodeURIComponent(request.bl)}`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const getDtcSummaryData = async (
  accId: any,
  tokenType: any,
  accessToken: any
) => {
  var getHeaders = new Headers();
  getHeaders.append("Authorization", `${tokenType} ${accessToken}`);
  getHeaders.append("Content-Type", "application/json");

  var requestOptions: any = {
    method: "GET",
    headers: getHeaders,
    redirect: "follow",
  };

  return await fetch(
    `${serviceAPIMapping["DTC-SETTLEMENT-PROCESSOR-SERVICE"].apiRouteURL}${EndPoint.dtcSummary}${accId}`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => {
      swal({
        title: constants.Error,
        text: error,
        dangerMode: true,
        closeOnClickOutside: false,
      });
      console.log("error", error);
    });
};

export const getDtcInData = async (
  accId: any,
  tokenType: any,
  accessToken: any
) => {
  var getHeaders = new Headers();
  getHeaders.append("Authorization", `${tokenType} ${accessToken}`);
  getHeaders.append("Content-Type", "application/json");

  var requestOptions: any = {
    method: "GET",
    headers: getHeaders,
    redirect: "follow",
  };

  return await fetch(
    `${serviceAPIMapping["DTC-SETTLEMENT-PROCESSOR-SERVICE"].apiRouteURL}${EndPoint.dtcActivity}${accId}`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => {
      swal({
        title: constants.Error,
        text: error,
        dangerMode: true,
        closeOnClickOutside: false,
      });
      console.log("error", error);
    });
};

export const getDtcOutData = async (
  accId: any,
  tokenType: any,
  accessToken: any
) => {
  var getHeaders = new Headers();
  getHeaders.append("Authorization", `${tokenType} ${accessToken}`);
  getHeaders.append("Content-Type", "application/json");

  var requestOptions: any = {
    method: "GET",
    headers: getHeaders,
    redirect: "follow",
  };

  return await fetch(
    `${serviceAPIMapping["DTC-SETTLEMENT-PROCESSOR-SERVICE"].apiRouteURL}${EndPoint.dtcContractActivity}${accId}`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => {
      swal({
        title: constants.Error,
        text: error,
        dangerMode: true,
        closeOnClickOutside: false,
      });
      console.log("error", error);
    });
};

export const getLoanReturns = async (
  accId: any,
  tokenType: any,
  accessToken: any
) => {
  var getHeaders = new Headers();
  getHeaders.append("Authorization", `${tokenType} ${accessToken}`);
  getHeaders.append("Content-Type", "application/json");

  var requestOptions: any = {
    method: "GET",
    headers: getHeaders,
    redirect: "follow",
  };

  return await fetch(
    `${serviceAPIMapping["RETURNS-SERVICE"].apiRouteURL}${EndPoint.callbacks}${accId}`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        // HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => {
      swal({
        title: constants.Error,
        text: error,
        dangerMode: true,
        closeOnClickOutside: false,
      });
      console.log("error", error);
    });
};

export const getAllocations = async (
  accId: any,
  tokenType: any,
  accessToken: any,
  cusip: any
) => {
  var headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("Authorization", `${tokenType} ${accessToken}`);
  var requestOptions: any = {
    method: "GET",
    headers: headers,
    redirect: "follow",
  };
  let url = `${serviceAPIMapping["RETURNS-SERVICE"].apiRouteURL}/returns?account_id=${accId}`;
  if (!_.isNull(cusip)) url = url + `&cusip=${cusip}`;
  return await fetch(url, requestOptions)
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => {
      swal({
        title: constants.Error,
        text: error,
        dangerMode: true,
        closeOnClickOutside: false,
      });
      console.log("error", error);
    });
};

export const getKPIInfo = async (request: any) => {
  var headers = new Headers();
  const accessToken = window.localStorage.getItem("refreshtoken");
  headers.append("Content-Type", "application/json");
  headers.append("Authorization", `Bearer ${accessToken}`);
  var raw = JSON.stringify(request);
  var requestOptions: any = {
    method: "POST",
    headers: headers,
    body: raw,
    redirect: "follow",
  };
  return fetch(
    `${serviceAPIMapping["REPORTING-SERVICE"].apiRouteURL + EndPoint.reportFn}`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const getContractBookingServiceHealthCheck = async () => {
  var headers = new Headers();
  headers.append("Content-Type", "application/json");
  const token = window.localStorage.getItem("refreshtoken");
  headers.append("Authorization", `Bearer ${token}`);

  var requestOptions: any = {
    method: "GET",
    headers: headers,
    redirect: "follow",
  };
  return fetch(
    `${serviceAPIMapping["CONTRACT-BOOKING-SERVICE"].apiRouteURL}/${EndPoint.actuator}`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      }
      // else {
      //   HandleAPIException(response);
      // }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const getTradeStateServiceHealthCheck = async () => {
  var headers = new Headers();

  headers.append("Content-Type", "application/json");
  const token = window.localStorage.getItem("refreshtoken");
  headers.append("Authorization", `Bearer ${token}`);

  var requestOptions: any = {
    method: "GET",
    headers: headers,
    redirect: "follow",
  };
  return fetch(`${BASE_URI()}/trade/${EndPoint.actuator}`, requestOptions)
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      }
      // else {
      //   HandleAPIException(response);
      // }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const updateContractMaintenance = async (
  request: any,
  tokenType: any,
  accessToken: any
) => {
  var headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("Authorization", `${tokenType} ${accessToken}`);

  var raw = JSON.stringify(request);
  var requestOptions: any = {
    method: "POST",
    headers: headers,
    body: raw,
    redirect: "follow",
  };
  return fetch(
    `${
      serviceAPIMapping["CONTRACT-BOOKING-SERVICE"].apiRouteURL +
      EndPoint.contractMaintenance
    }`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const contractsUpdate = async (
  request: any,
  tokenType: any,
  accessToken: any
) => {
  var headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("Authorization", `${tokenType} ${accessToken}`);

  var raw = JSON.stringify(request);
  var requestOptions: any = {
    method: "POST",
    headers: headers,
    body: raw,
    redirect: "follow",
  };
  return fetch(
    `${
      serviceAPIMapping["CONTRACT-BOOKING-SERVICE"].apiRouteURL +
      EndPoint.contractMaintenanceUpdate
    }`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const getRecallDetails = async (request: any) => {
  var headers = new Headers();
  headers.append("Content-Type", "application/json");
  const token = window.localStorage.getItem("refreshtoken");
  headers.append("Authorization", `Bearer ${token}`);
  var raw = JSON.stringify(request);
  var requestOptions: any = {
    method: "POST",
    headers: headers,
    body: raw,
    redirect: "follow",
  };
  return fetch(
    `${serviceAPIMapping["RECALL-SERVICE"].apiRouteURL}/${EndPoint.recallBorrows}`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const getRecallDetailsAndOutstandingLoans = async (request: any) => {
  var headers = new Headers();
  headers.append("Content-Type", "application/json");
  const token = window.localStorage.getItem("refreshtoken");
  headers.append("Authorization", `Bearer ${token}`);
  var raw = JSON.stringify(request);
  var requestOptions: any = {
    method: "POST",
    headers: headers,
    body: raw,
    redirect: "follow",
  };
  return fetch(
    `${serviceAPIMapping["RECALL-SERVICE"].apiRouteURL}/${EndPoint.recallLoans}`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const getRecallActivityByLenderRefId = async (request: any) => {
  var headers = new Headers();
  headers.append("Content-Type", "application/json");
  const token = window.localStorage.getItem("refreshtoken");
  headers.append("Authorization", `Bearer ${token}`);
  var raw = JSON.stringify(request);
  var requestOptions: any = {
    method: "POST",
    headers: headers,
    body: raw,
    redirect: "follow",
  };
  return fetch(
    `${
      serviceAPIMapping["RECALL-SERVICE"].apiRouteURL + EndPoint.recallActivity
    }`,
    requestOptions
  )
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const isServiceHealthy = async (url: string) => {
  var headers = new Headers();

  headers.append("Content-Type", "application/json");
  const token = window.localStorage.getItem("refreshtoken");
  headers.append("Authorization", `Bearer ${token}`);

  var requestOptions: any = {
    method: "GET",
    headers: headers,
    redirect: "follow",
  };
  return fetch(`${url}`, requestOptions)
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      }
      return response;
    })
    .catch((error) => console.log("error", error));
};

export const getReturnsByContract = async (request: any) => {
  var headers = new Headers();
  headers.append("Content-Type", "application/json");
  const token = window.localStorage.getItem("refreshtoken");
  headers.append("Authorization", `Bearer ${token}`);
  var raw = JSON.stringify(request);
  var requestOptions: any = {
    method: "POST",
    headers: headers,
    redirect: "follow",
    body: raw,
  };
  let url = `${serviceAPIMapping["RETURNS-SERVICE"].apiRouteURL}/returnsByContract`;
  return await fetch(url, requestOptions)
    .then(async (response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        window.localStorage.clear();
      } else {
        HandleAPIException(response);
      }
      return response;
    })
    .catch((error) => {
      swal({
        title: constants.Error,
        text: error,
        dangerMode: true,
        closeOnClickOutside: false,
      });
      console.log("error", error);
    });
};